<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :aria-labelledby="iconName"
    role="presentation"
    :class="className"
    v-html="SVGChildren"
    :fill="color"
  >
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      required: true
    },
    color: {
      type: String,
    },
    className:  {
      type: String,
    },
  },
  data() {
    return {
      SVGDom: null,
      SVGChildren: null,
      width: null,
      height: null,
      viewBox: null
    }
  },
  created: async function() {
    try {
      await this.setSVGDom();
      this.setSVGChildren();
      this.setSVGAttributes();
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    setSVGDom: async function() {
      const SVG = await this.fetchSVG();
      this.SVGDom = new DOMParser().parseFromString(SVG, 'text/xml');
    },
    fetchSVG: async function() {
      const filePath = './../../../dist/sprites/' + this.iconName;
      let res = await fetch(filePath);
      let svg = res.text();
      return svg;
    },
    setSVGChildren: function() {
      const svg = this.SVGDom.getElementsByTagName('svg')[0];
      let children = '';
      Array.from(svg.children).forEach(child => {
        children += child.outerHTML;
      });
      this.SVGChildren = children;
    },
    setSVGAttributes: function() {
      const SVGWidth = this.getSVGAttribute('width');
      const SVGHeight = this.getSVGAttribute('height');
      const SVGViewBox = this.getSVGAttribute('viewBox');

      if (SVGWidth != null) this.width = SVGWidth;
      if (SVGHeight != null) this.height = SVGHeight;
      if (SVGViewBox != null) this.viewBox = SVGViewBox;
    },
    getSVGAttribute: function(attribute) {
      return this.SVGDom.firstElementChild.getAttribute(attribute);
    }
  }
}
</script>
